export enum TimeOffStatus {
  Pending = 'PENDING',
  Approved = 'APPROVED',
  Declined = 'DECLINED',
  Cancelled = 'CANCELLED',
}
